import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FomanticUIModule } from 'ngx-fomantic-ui';

import { CouponCodeComponent } from './components/coupon-code/coupon-code.component';
import { EmailSubscriptionComponent } from './email-subscription/email-subscription.component';

@NgModule({
  imports: [CommonModule, FomanticUIModule, ReactiveFormsModule, FormsModule],
  declarations: [CouponCodeComponent, EmailSubscriptionComponent],
  exports: [CouponCodeComponent, EmailSubscriptionComponent],
})
export class WidgetsModule {}
